import { createContext } from 'react';
export const BreadcrumbFocusGroupIDContext = createContext('');
